import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from "../_virtual/_rollupPluginBabelHelpers.js";
var VideoSample = /* @__PURE__ */ function() {
  function VideoSample2(pts, dts, units) {
    _classCallCheck(this, VideoSample2);
    _defineProperty(this, "flag", {});
    _defineProperty(this, "keyframe", false);
    _defineProperty(this, "gopId", 0);
    _defineProperty(this, "duration", 0);
    _defineProperty(this, "size", 0);
    _defineProperty(this, "units", []);
    _defineProperty(this, "chromaFormat", 420);
    this.originPts = this.pts = pts;
    this.originDts = this.dts = dts;
    if (units)
      this.units = units;
  }
  _createClass(VideoSample2, [{
    key: "cts",
    get: function get() {
      return this.pts - this.dts;
    }
  }, {
    key: "setToKeyframe",
    value: function setToKeyframe() {
      this.keyframe = true;
      this.flag.dependsOn = 2;
      this.flag.isNonSyncSample = 0;
    }
  }]);
  return VideoSample2;
}();
export { VideoSample };
